import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// LOC-088: the member's portfolio order on the Gear & portfolio step. Rows are
// dragged by their handle (SortableJS, as in sortable_controller.js) or moved
// with Move up / Move down; either way the whole order is sent to the order
// endpoint. Without JavaScript the handles stay hidden and the move buttons
// submit their own forms, which redirect back to the step.
export default class extends Controller {
  static targets = ["list", "row", "handle", "status"];
  static values = { url: String, saved: String, failed: String };

  connect() {
    this.handleTargets.forEach((handle) => (handle.hidden = false));
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".handle",
      draggable: "[data-locals-portfolio-order-target='row']",
      animation: 150,
      onEnd: (event) => {
        if (event.oldIndex === event.newIndex) return;
        this.refreshButtons();
        this.save();
      },
    });
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy();
  }

  // The move buttons sit in button_to forms; stop the submit and move the row
  // here, so the page is not reloaded and focus stays on the moved item.
  move(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const row = button.closest("[data-locals-portfolio-order-target='row']");
    const up = button.dataset.direction === "up";
    const sibling = up ? row.previousElementSibling : row.nextElementSibling;
    if (!sibling) return;

    if (up) sibling.before(row);
    else sibling.after(row);
    this.refreshButtons();
    // At the top or bottom the pressed button is now disabled; keep focus in
    // the row on the other one.
    const focusable = button.disabled ? row.querySelector(`[data-direction='${up ? "down" : "up"}']`) : button;
    focusable.focus();
    this.save();
  }

  refreshButtons() {
    const rows = this.rowTargets;
    rows.forEach((row, index) => {
      row.querySelector("[data-direction='up']").disabled = index === 0;
      row.querySelector("[data-direction='down']").disabled = index === rows.length - 1;
    });
  }

  save() {
    const token = document.querySelector("meta[name='csrf-token']");
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token ? token.content : "",
      },
      body: JSON.stringify({ ids: this.rowTargets.map((row) => row.dataset.id) }),
    })
      .then((response) => this.announce(response.ok ? this.savedValue : this.failedValue))
      .catch(() => this.announce(this.failedValue));
  }

  announce(message) {
    if (!this.hasStatusTarget) return;
    this.statusTarget.textContent = "";
    // A fresh text node after clearing, so a repeated message is read again.
    window.setTimeout(() => (this.statusTarget.textContent = message), 50);
  }
}
